null!=function(r){if(r=r||navigator.userAgent,r=/\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(r))return parseInt(r[2])}()&&document.write('<script src="assets/scripts/unsupported-browsers.min.js" defer ><\/script>');
